export const BALANCED_UPDATED = 'balanceUpdated'
export const TRANSACTION_COMPLETED = 'transactionCompleted'
